export function getNavigationParams(url) {
  if (window.location.href.includes("from=portal")) {
    url = url.concat("?from=portal");
  }
  return url;
}
